import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { pluralizeWord } from 'common/utils/pluralizeWord';

const THEME = 'theme';
const EVENT = 'event';
const AND_TEXT = ' and ';

export const UPDATE_EXISTING_DESCRIPTION = 'Clicking confirm will save your form template changes on';
const SAVE_AS_COPY_DESCRIPTION = `Clicking confirm will save your changes as the new default form on this event.
This unique form will not appear on any other themes or events, nor will it appear in the form library until it is
added as a new form template.`;
export const APPLY_DESCRIPTION_PART_1 = 'Clicking confirm will apply ';
export const APPLY_DESCRIPTION_PART_2 = ` to this event. It will replace the default form,
but you can still make additional changes.`;

const BoldText = styled.span`
    font-weight: bold;
`;

const SAVE_AS_COPY_CONFIRMATION = 'saveAsCopyConfirmation';
export const UPDATE_EXISTING_CONFIRMATION = 'updateExistingConfirmation';
export const APPLY_CONFIRMATION = 'applyConfirmation';

const descriptions = {
    [UPDATE_EXISTING_CONFIRMATION]: UPDATE_EXISTING_DESCRIPTION,
    [SAVE_AS_COPY_CONFIRMATION]: SAVE_AS_COPY_DESCRIPTION,
};

const COMPONENT_NAME = 'ScaledFormsConfirmationContent';

const StyledModalContent = styled.div`
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
`;

const DescriptionText = styled.p`
    width: ${({ shownModalContent }) => (shownModalContent === APPLY_CONFIRMATION ? '54%' : '100%')};
    align-self: center;
`;

const ScaledFormsConfirmationContent = ({ shownModalContent, themeCount, eventCount, formName }) => (
    <StyledModalContent>
        {shownModalContent === APPLY_CONFIRMATION ? (
            <DescriptionText shownModalContent={shownModalContent} data-qa={`${COMPONENT_NAME}-description`}>
                {APPLY_DESCRIPTION_PART_1}
                <BoldText>{formName}</BoldText>
                {APPLY_DESCRIPTION_PART_2}
            </DescriptionText>
        ) : (
            <DescriptionText shownModalContent={shownModalContent} data-qa={`${COMPONENT_NAME}-description`}>
                {descriptions[shownModalContent]}
            </DescriptionText>
        )}
        {Boolean(themeCount || eventCount) && (
            <p data-qa={`${COMPONENT_NAME}-theme-and-event-count`}>
                <BoldText>
                    {themeCount} {pluralizeWord(THEME, themeCount)}
                </BoldText>
                {AND_TEXT}
                <BoldText>
                    {eventCount} {pluralizeWord(EVENT, eventCount)}
                </BoldText>
            </p>
        )}
    </StyledModalContent>
);

ScaledFormsConfirmationContent.propTypes = {
    shownModalContent: PropTypes.string.isRequired,
    themeCount: PropTypes.number,
    eventCount: PropTypes.number,
    formName: PropTypes.string,
};

ScaledFormsConfirmationContent.defaultProps = {
    isLoading: false,
    themeCount: 0,
    eventCount: 0,
    formName: null,
};

export default ScaledFormsConfirmationContent;
